import { useSelector } from 'react-redux';
import pagesEng from '../languages/eng.pages.json';
import pagesAlb from '../languages/alb.pages.json';

const languageMap = {
  eng: pagesEng,
  alb: pagesAlb
};


const getNestedValue = (obj, path) => {
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
};

// Custom hook
export const useTranslation = () => {
  const { language } = useSelector(state => state.language);
  const { general = {}, pages = {} } = languageMap[language] || {};

  const t = (key) => {
    const generalValue = getNestedValue(general, key);
    if (generalValue) return generalValue;

    const pageValue = getNestedValue(pages, key);
    if (pageValue) return pageValue;

    return key; // fallback
  };

  return { t };
};
